// extracted by mini-css-extract-plugin
module.exports = {"selector":"order_selector__2zeC_","text_order":"order_text_order__-jEEB"};